//@flow
import * as _ from 'lodash';
import { urlsConstants } from '../_constants/urls.constant';
import { oauthHeader, oauthHeaderJson } from '../_helpers/oauth-header';
import { defaultService } from './defaultService';

export const usuarioFinanceiroService = {
  doGet,
  doSave,
  findByFiltro,
};

function findByFiltro(options: Options, filter: any) {
  return defaultService.findByFiltro(
    `${urlsConstants.USUARIO}financeiro/list`,
    options,
    filter
  );
}

function doGet(id) {
  return defaultService.doGet(`${urlsConstants.USUARIO}${id}`);
}

function doSave(usuario: usuario) {
  return defaultService.doSave(`${urlsConstants.USUARIO}financeiro/`, usuario);
}
